import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: []
    },
    lastName: {
      validations: []
    },
    email: {
      validations: [
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    clientname: {
      validations: []
    },
    eventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    Category: {
      validations: [
      ]
    },
    theme: {
      validations: []
    },
    plannedguestcount: {
      validations: [
        {type: 'regex', pattern: '^[0-9]*$', message: 'Please provide a guest count in numbers only.'},
      ]
    },
    Reference: {
      validations: []
    },
    Sitename: {
      validations: []
    },
    SiteAddress: {
      validations: []
    },
    SiteCity: {
      validations: []
    },
    SiteState: {
      validations: []
    },
    SitePostal: {
      validations: [
        { type: 'maxLength', maxLength: 5, message: 'Enter 5 digit zip code' }
      ]
    },
    Description: {
      validations: []
    },
    SalesRep: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:',
            mapping: 'firstName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email Address:',
            mapping: 'email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number:',
            mapping: 'telNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company/Client Name:',
            mapping: 'clientname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:',
            mapping: 'eventDate'
          }
        ]
      },
      {
        fields: [
          {
                type: 'multiple-choice',
                size: 'Medium',
                label: 'Catering Menu Selection:',
                options: [
                  {label: 'BBQ Blowout Menu' , value: 'BBQ Blowout Menu' },
                  {label: 'New England Clambake' , value: 'New England Clambake' },
                  {label: 'Yankee Clambake' , value: 'Yankee Clambake' },
                  {label: 'Boston Clambake' , value: 'Boston Clambake' },
                  {label: 'Ultimate Clambake' , value: 'Ultimate Clambake' },
                  {label: 'Deluxe Wedding Clambake' , value: 'Deluxe Wedding Clambake' },
                  {label: 'Custom' , value: 'Custom' },
                  {label: 'Same as last time' , value: 'Same as last time' },
                  {label: 'Bar' , value: 'Bar' },
                ],
                mapping: 'Category'
              }
            ]
          },
          {
            fields: [
              {
                type: 'multiple-choice',
                size: 'Medium',
                label: 'Event Type Selection:',
                options: [
                  {label: 'BBQ' , value: 'BBQ' },
                  {label: 'Corporate Event' , value: 'Corporate Event' },
                  {label: 'Clambake' , value: 'Clambake' },
                  {label: 'Family Event' , value: 'Family Event' },
                  {label: 'Custom Event' , value: 'Custom Event' },
                  {label: 'Wedding' , value: 'Wedding' },
                ],
                mapping: 'theme'
              }
            ]
          },
          {
            fields: [
              {
            type: 'text',
            size: 'Medium',
            label: 'Number of Guests:',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Budget Per Person:',
            options:[
              {label: '$25 - $35' , value: '$25 - $35'},
              {label: '$36 - $45' , value: '$36 - $45'},
              {label: '$46 - $55' , value: '$46 - $55'},
              {label: '$56 +' , value: '$56 +'},
            ],
            mapping: 'Reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Site Name:',
            mapping: 'Sitename'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Site Address:',
            mapping: 'SiteAddress'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Site City:',
            mapping: 'SiteCity'
          }
        ]
      }, 
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Site Zip Code:',
            mapping: 'SitePostal'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'How Did You Hear About Us?:',
            options:[
              {label:'Internet Search' , value: 'Internet Search'},
              {label:'Referred by a Friend' , value: 'Referred by a Friend' },
              {label:'Attended an Event' , value: 'Attended an Event'},
              {label:'Love the Restaurant' , value: 'Love the Restaurant'},
              {label:'Social Media' , value: 'Social Media'},
              {label:'I\'m a Repeat Customer' , value: 'I\'m a Repeat Customer'},
            ],
            mapping: 'Description'
          }
        ]
      }, 
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Planner',
            options:[
              {label: 'Ken Siegel'}
            ],
            mapping: 'SalesRep'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'XLarge',
            label: 'Is there any additional information you would like to add?:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SEND'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Ipswich Clambake Company Contact Us Form',
    formId: '1862',
    clientKey: '58B9E870-7CF7-48D8-985E-48B931007CC1',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
